import registerBinding from "common/bindings/registerBinding";

const ActionBinding = kendo.data.Binder.extend({

    eventName: "click",
    promiseFunction: "value",

    init: function() {
        kendo.data.Binder.fn.init.apply(this, arguments);
        this._fire = $.proxy(this._fire, this);
        this.element.bind(this.eventName, this._fire);
    },

    call(e) {
        return this.bindings.action.get();
    },

    _fire(e) {
        this.element[this.promiseFunction]($.when(this.call(e)));
    },

    refresh: function() {}
});


const dfbutton = registerBinding.widget("dfbutton", "action", ActionBinding.extend({
    eventName: "click",
    promiseFunction: "value"
}));

const penciledit = registerBinding.widget("penciledit", "action", ActionBinding.extend({
    eventName: "update",
    promiseFunction: "progress"
}));

const menubutton = registerBinding.widget("menubutton", "action", ActionBinding.extend({
    eventName: "select"
}));

const menubuttonActionEvent = registerBinding.widget("menubutton", "actionEvent", menubutton.extend({
    call(e) {
        return this._getEvent()(e);
    },
    _getEvent() {
        const binding = this.bindings.actionEvent;
        const parents = [];
        let source = binding.source;
        let index = 0, handler;
        for(let now = binding.source; now && now.parent; now = now.parent()) {
            if(now instanceof kendo.data.ObservableObject) {
                parents.push(now);
            }
        }
        binding.parents = parents;
        handler = source.get(binding.path);
        while(!handler && source) {
            source = binding.parents[++index];
            handler = source.get(binding.path);
        }
        return $.proxy(handler, source);
    }
}));

/**
 * Special variant of the action binding for PopUpWindow.  It works like the event binding.
 */
const popupwindow = registerBinding.widget("popupwindow", "action", ActionBinding.extend({
    eventName: "action",
    promiseFunction: "linkRequest",
    init: function() {
        ActionBinding.fn.init.apply(this, arguments);
        this._path = $.extend({}, this.bindings.action.path);
    },
    call(e) {
        if(e.event && this._path[e.event]) {
            this.bindings.action.path = this._path[e.event];
            return this.bindings.action.get();
        }
    }
}));

export default {
    dfbutton,
    menubutton,
    penciledit,
    popupwindow
}
